var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrevArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 11,
    viewBox: "0 0 6 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.40623 10.904C5.48523 10.9044 5.56355 10.8893 5.63669 10.8594C5.70983 10.8295 5.77635 10.7855 5.83244 10.7299C5.88871 10.6741 5.93337 10.6077 5.96384 10.5345C5.99432 10.4614 6.01001 10.3829 6.01001 10.3037C6.01001 10.2244 5.99432 10.1459 5.96384 10.0728C5.93337 9.99964 5.88871 9.93324 5.83244 9.87744L1.45022 5.50122L5.83244 1.12501C5.94548 1.01197 6.00899 0.858653 6.00899 0.698791C6.00899 0.619636 5.99339 0.541255 5.9631 0.468125C5.93281 0.394995 5.88841 0.328547 5.83244 0.272576C5.77647 0.216604 5.71002 0.172205 5.63689 0.141914C5.56376 0.111622 5.48538 0.0960312 5.40623 0.0960312C5.24636 0.0960312 5.09305 0.159536 4.98001 0.272576L0.177579 5.07501C0.121313 5.13081 0.076653 5.19721 0.0461764 5.27036C0.0156999 5.34351 9.53674e-06 5.42197 9.53674e-06 5.50122C9.53674e-06 5.58047 0.0156999 5.65893 0.0461764 5.73208C0.076653 5.80524 0.121313 5.87163 0.177579 5.92744L4.98001 10.7299C5.0361 10.7855 5.10263 10.8295 5.17576 10.8594C5.2489 10.8893 5.32722 10.9044 5.40623 10.904Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevArrow);
export default __webpack_public_path__ + "static/media/prev-arrow.0a477d628b603e7b8c6db7cca84f25aa.svg";
export { ForwardRef as ReactComponent };